import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=19d1f51f&scoped=true&"
import script from "./TableModal.vue?vue&type=script&lang=js&"
export * from "./TableModal.vue?vue&type=script&lang=js&"
import style0 from "./TableModal.vue?vue&type=style&index=0&id=19d1f51f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1f51f",
  null
  
)

export default component.exports